import { Button, ButtonProps, styled } from "@mui/material";

const ButtonBack = styled(Button)<ButtonProps>(({ theme }) => ({
  color: "#000",
  backgroundColor: "#fff",
  border: "1px solid #9f1831",
  "&:hover": {
    backgroundColor: "#fff",
  },
  "&:disabled": {
    opacity: 0.5,
  },
}));

export default ButtonBack;
